import { useEffect, useRef, useState } from "react";
import api from "../services/api";

const IDLE_LIMIT_MS = 300 * 1000;
const HEARTBEAT_INTERVAL_MS = 15 * 1000;
const ACTIVITY_EVENTS = [
  "mousemove",
  "mousedown",
  "keydown",
  "scroll",
  "touchstart",
];

const todayISO = () => new Date().toISOString().slice(0, 10);

const formatHMS = (totalSeconds) => {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = String(Math.floor(s / 3600)).padStart(2, "0");
  const m = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
  return `${h}:${m}`;
};

export function useStudyTimeTracker(alunoId) {
  const [segundosHoje, setSegundosHoje] = useState(0);
  const [ativo, setAtivo] = useState(false);

  const lastActivityRef = useRef(Date.now());
  const naoEnviadosRef = useRef(0);
  const dataRef = useRef(todayISO());

  useEffect(() => {
    if (!alunoId) return undefined;

    const marcarAtividade = () => {
      lastActivityRef.current = Date.now();
    };
    ACTIVITY_EVENTS.forEach((evt) =>
      window.addEventListener(evt, marcarAtividade, { passive: true }),
    );

    let cancelado = false;
    api
      .get("/tempo-estudado", { params: { aluno_id: alunoId } })
      .then((res) => {
        if (cancelado) return;
        const data = res.data?.data ?? res.data;
        setSegundosHoje(Number(data?.segundos_hoje || 0));
      })
      .catch(() => {});

    const enviarHeartbeat = () => {
      const segundos = naoEnviadosRef.current;
      if (segundos <= 0) return;
      naoEnviadosRef.current = 0;
      api
        .post("/tempo-estudado/heartbeat", { aluno_id: alunoId, segundos })
        .catch(() => {
          naoEnviadosRef.current += segundos;
        });
    };

    const tick = setInterval(() => {
      const hojeAgora = todayISO();
      if (hojeAgora !== dataRef.current) {
        dataRef.current = hojeAgora;
        setSegundosHoje(0);
        naoEnviadosRef.current = 0;
        return;
      }

      const estaAtivo = Date.now() - lastActivityRef.current < IDLE_LIMIT_MS;
      setAtivo(estaAtivo);
      if (estaAtivo) {
        setSegundosHoje((s) => s + 1);
        naoEnviadosRef.current += 1;
      }
    }, 1000);

    const heartbeatTimer = setInterval(enviarHeartbeat, HEARTBEAT_INTERVAL_MS);

    const onVisibilityChange = () => {
      if (document.hidden) enviarHeartbeat();
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      cancelado = true;
      clearInterval(tick);
      clearInterval(heartbeatTimer);
      ACTIVITY_EVENTS.forEach((evt) =>
        window.removeEventListener(evt, marcarAtividade),
      );
      document.removeEventListener("visibilitychange", onVisibilityChange);
      enviarHeartbeat();
    };
  }, [alunoId]);

  return { segundosHoje, formatado: formatHMS(segundosHoje), ativo };
}
